import { Controller } from "@hotwired/stimulus"
import { reducedMotion } from "~/lib/motion"

// Fades .reveal elements in as they scroll into view (styles in base/motion.css).
// Content is only hidden once this controller is running, so nothing stays
// invisible without JS or with reduced motion.
export default class extends Controller {
  connect() {
    if (reducedMotion) return
    document.documentElement.classList.add("has-reveal")
    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        entry.target.classList.add("is-visible")
        this.observer.unobserve(entry.target)
      }
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" })
    this.element.querySelectorAll(".reveal").forEach((el) => this.observer.observe(el))
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
